import { InjectionToken, inject } from '@angular/core';
import { API_URL } from './api-url.token';

// Base URL for the tutor-facing API surface (backend's `Api.Client` split, routed under
// `/api/app`). Kept as its own token rather than string-concatenating `${API_URL}/api/app` at each
// call site so the prefix can move (or the surface can get its own origin entirely) by editing
// this one factory -- see docs/contrato-api-app.md.
export const CLIENT_API_BASE = new InjectionToken<string>('CLIENT_API_BASE', {
  providedIn: 'root',
  factory: () => `${inject(API_URL)}/api/app/v1`,
});
